// extracted by mini-css-extract-plugin
module.exports = {"boxBtnAdd":"_31eeQC4cmAyJztAyGp8-MX"};